export const ARTIFACTS_ROOT = '/artifacts'

/** Stable artifact-page route for a cited artifact id. */
export function artifactHref(id: string): string {
  return `${ARTIFACTS_ROOT}/${encodeURIComponent(id)}`
}
